<template>
  <div class="mobile-sidebar-wrapper">
    <transition name="my-fade">
      <div class="root-sidebar" v-show="!flag || open">
        <div class="side-btn" v-show="flag">
          <app-btn styling="outline" icon="close"  @click="open = !open"></app-btn>
        </div>
        <div class="sidebar">
          <slot name="sidebar"/>
        </div>
      </div>
    </transition>

    <div class="close-side" v-if="flag">
      <div class="side-btn">
        <app-btn styling="outline" icon="arrow_back"  @click="open = !open">
          List
        </app-btn>
      </div>
    </div>

    <div class="mobile-sidebar-content">
      <slot name="content"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    param: String,
    params: Array
  },
  data () {
    return {
      open: true,
      flag: false,
      oldParam: false
    }
  },
  created () {
    this.close();
    if (window.innerWidth <= 768) {
      this.flag = true;
    }
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.close();
  },
  methods: {
    close () {
      if (this.param) {
        this.check(this.param);
      } else if (this.params) {
        for (var item of this.params) {
          this.check(item);
        }
      }
    },
    check (param) {
      if (this.$route.params[param]) {
        if (this.oldParam == false || this.oldParam != this.$route.params[param]) {
          this.open = false;
          this.oldParam = this.$route.params[param];
        }
      }
    }
  },
  watch: {
    '$route.params': function (val) {
      this.close();
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
   .root-sidebar > .sidebar > *, .mobile-sidebar-content > * {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    // height: 100%;

    // @media (max-width: 768px) {
    //   height: auto;
    //   min-height: 100%;
    // }
  }
}

.my-fade-enter, .my-fade-leave-to {
  transform: translateX(-100%);
}
.my-fade-enter-active, .my-fade-leave-active {
  transition: transform 0.3s;
}
.my-fade-enter-to, .my-fade-leave {
  transform: translateX(0);
}

.mobile-sidebar-wrapper {
  width: 100%;
  display: flex;
  height: 100%;

  .close-side {
    // position: absolute;
    overflow-y: auto;
    background: inherit;
    // z-index: 10;
    // height: calc(100% - 60px);
    width: 100%;
    top: 0;
    left: 0;
    padding-bottom: 20px;
  }

  > .root-sidebar {
    width: 320px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: fit-content;
    height: -moz-fit-content;
    height: -webkit-fit-content;
    > .sidebar {
      width: 100%;
      min-height: 100%;
    }
    .side-btn {
      cursor: pointer;
    }

    @media (max-width: 768px) {
      overflow-y: auto;
      z-index: 10;
      width: 100%;
      max-width: 350px;
      background: #fff;
      padding: 15px;
      position: fixed;
      height: 100vh;
      box-sizing: border-box;
      top: 0;
      left: 0;

      .side-btn {
        margin-bottom: 20px;
      }

      > .sidebar {
        display: block;
        height: calc(100% - 25px);
        min-height: auto;
        overflow-y: auto;
      }

    }
  }
  .mobile-sidebar-content {
    width: calc(100% - 320px);

    @media (max-width: 768px) {
      width: 100%;
      display: flex;
      justify-content: center;
      // padding-top: 40px;
    }
  }

  @media (max-width: 768px) {
    position: relative;
    flex-direction: column;
  }
}

#labs, #drainages {
  .root-sidebar {
    position: fixed;
  }
  .mobile-sidebar-content {
    margin-left: 320px;
  }
}
</style>
